import { render } from "./layout.vue?vue&type=template&id=a09a61f8&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=a09a61f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a09a61f8"

export default script